import gql from 'graphql-tag'
import { deliveryNoteItems } from '../fragments'

export default gql`
query CAmaster_listDeliveryNotes($id: ID!, $dateInterval: FullDateTimeIntervalInput) {
	cashAssist {
		listDeliveryNotes(filter: {creditClientId: $id, dateInterval: $dateInterval}) {
            ...deliveryNoteItems
		}
	}
}
${deliveryNoteItems}`
